import {createActions} from 'redux-actions';

export const {clearPreviousSelectedItem} = createActions({CLEAR_PREVIOUS_SELECTED_ITEM: () => {}});
